import { render, staticRenderFns } from "./localizacion_cliente.vue?vue&type=template&id=a365b3b2&"
import script from "./localizacion_cliente.vue?vue&type=script&lang=js&"
export * from "./localizacion_cliente.vue?vue&type=script&lang=js&"
import style0 from "./localizacion_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports